import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-devices-tab.component'

let module = angular.module('myDevicesTab', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.manageMyRlink.myUpdates.myDevicesTab', {
      url: '/devices',
      component: 'myDevicesTab',
      authenticate: true
    })
})

.component('myDevicesTab', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-devices-tab/index.js